<template>
  <v-form v-on:submit.prevent="addOven()">
    <v-card>
      <v-alert v-model="addOvenAlert" dismissible type="error">{{ addOvenAlertMessage }}</v-alert>
      <v-card-title>
        <span class="headline">{{ $t('settings.ovenAddEdit.titleAdd') }}</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12 v-if="errorMessage" class="red--text">{{ errorMessage }}</v-flex>

            <v-flex xs12>
              <v-text-field label="Adresse MAC" v-model="macAddress" mask="NN:NN:NN:NN:NN:NN"
                @change.prevent="addOven()"></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="displayCodeField">
              <v-text-field label="Code" v-model="code"></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn color="black" flat large @click="$emit('close'); resetAll()">{{ $t('global.cancel') }}</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="green darken-1" flat large @click="addOven()">{{ $t('global.save') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>



<script>
export default {
  data: () => ({
    addOvenAlert: false,
    addOvenAlertMessage: null,
    macAddress: null,
    code: null,
    displayCodeField: false,
    errorMessage: null
  }),
  computed: {},
  watch: {},
  methods: {
    // ajout d'un four
    async addOven(event) {
      // check les données
      var result = await this.$validator.validate();

      if (!result) {
        // impossible de valider !
        return;
      }

      // si pas de code, demande de code
      if (!this.displayCodeField) {
        this.api
          .post("/clients/me/ovens_code", {
            macAddress: this.macAddress
          })
          .then(() => {
            this.displayCodeField = true;
          })
          .catch(err => {
            this.errorMessage = err.message;
            console.error(err);
          });
        return;
      }

      // association
      this.api
        .post("/clients/me/ovens", {
          code: this.code,
          macAddress: this.macAddress
        })
        .then(res => {
          // cache la dialog
          this.$emit("close");
          // reset
          this.resetAll();

          // recharge la liste
          return this.$store.dispatch("loadOvenList");
        })

        .catch(err => {
          this.errorMessage = err.message;
          console.error(err.message);
        });
    },
    // reset tout
    resetAll() {
      // reset validation
      this.$validator.reset();
      // reset le formulaire et l'alerte
      this.macAddress = null;
      this.displayCodeField = false;
      this.code = null;
      //
      this.addOvenAlert = false;
      this.addOvenAlertMessage = null;
    }
  },
  mounted() { }
};
</script>
